import { mapLinkableEntityType } from '@api';
import type { AnnouncementEventType as ApiAnnouncementEventType } from 'src/api/generated/touring/types';
import type { AnnouncementEventType } from '../../types';

export const mapAnnouncementEventType = (
  api: ApiAnnouncementEventType
): AnnouncementEventType => ({
  date: api.date,
  startTime: api.startTime ?? null,
  duration: api.duration ?? null,
  artist: mapLinkableEntityType(api.artist),
  tour: mapLinkableEntityType(api.tour),
  type: api.type,
});
